import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { DesignPartnerDomainsService } from '../../services/design-partner-domains.service';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-domains',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './domains.component.html',
  styleUrl: './domains.component.less',
})
export class DomainsComponent implements OnInit {
  domains: any[] = [];
  isLoading: boolean = false;
  noDomainsMessage: string = 'No domains added yet.';

  constructor(
    private domainsService: DesignPartnerDomainsService,
    private authService: AuthService,
    private toaster: ToastService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const user = this.authService.getUser();
    if (user?.role !== 'design_partner') {
      this.router.navigate(['/dashboard']);
      return;
    }
    this.loadDomains();
  }

  loadDomains(): void {
    this.isLoading = true;
    this.domainsService.getDomains().subscribe({
      next: (response: any) => {
        this.domains = response?.data ?? response ?? [];
        if (!Array.isArray(this.domains)) this.domains = [];
        this.isLoading = false;
        if (this.domains.length === 0) {
          this.noDomainsMessage = 'No domains added yet. Click "Add New" to get started.';
        }
      },
      error: () => {
        this.isLoading = false;
        this.noDomainsMessage = 'Failed to load domains. Please try again later.';
        this.toaster.showToast('Failed to load domains', 'error');
      },
    });
  }

  addNew(): void {
    this.router.navigate(['/domains/add']);
  }

  viewSubDomains(domain: string): void {
    this.router.navigate(['/domains', domain]);
  }
}
